var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrap"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_c('div',[_vm._v("正在加载中...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }